import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import OTPInput from "otp-input-react";
import { otpForgetPassword } from "../../services/Action/OTPAction";
import "react-toastify/dist/ReactToastify.css";
import {
	AppShell,
	Text,
	useMantineTheme,
	Image,
	Group,
	Box,
	Container,
	Center,
	MediaQuery,
	Loader,
	Button,
} from "@mantine/core";
import imageIcon from "../../static/svg/ivistlogin.svg";
import Footr from "../../components/Footr";
import {
	showErrorNotification,
	showSuccessNotification,
} from "../../utils/Notifications";
function OTPForgotPassword() {
	const navigator = useNavigate();
	const [OTP, setOTP] = useState("");
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const theme = useMantineTheme();
	const otpHandler = async () => {
		setLoading(true);
		const data = dispatch(await otpForgetPassword(OTP));
		if (data.payload.msg == "code matched") {
			setLoading(false);
			showSuccessNotification("Registerd Sucessfully");
			navigator("/resetPassword");
		} else {
			setLoading(false);
			showErrorNotification("Inavlid OTP");
		}
	};
	return (
		<AppShell
			styles={{
				main: {
					position: "relative",
					minHeight: "calc(100vh - 48px)",
					maxHeight: "auto",
					background:
						theme.colorScheme === "dark"
							? theme.colors.ivisit_dark[0]
							: theme.colors.gray[0],
				},
			}}
			footer={<Footr />}
		>
			<div
				className="OTP_btn"
				style={{
					background: "#040F1F",
					margin: "auto",
				}}
			>
				<ToastContainer />
				<Container mt={10} size="xs" px="xs">
					<Group
						style={{
							width: "55%",
							margin: "auto",
						}}
					>
						<Image src={imageIcon} width="100%" pb={30} pt={50} />
					</Group>
					<MediaQuery smallerThan={500} styles={{ fontSize: "1rem" }}>
						<Text
							style={{
								color: "white",
							}}
							className="OTPText"
							align="center"
							size="xl"
							weight={700}
							pb={20}
						>
							Forgot Password
						</Text>
					</MediaQuery>
					<MediaQuery
						smallerThan={500}
						styles={{
							fontSize: "1rem",
							fontFamily: "SFPro Display ",
						}}
					>
						<Text
							style={{
								color: "white",
								fontFamily: "SFPro Display ",
							}}
							className="OTPText"
							align="center"
							size="md"
							mt={50}
							weight={500}
						>
							Enter the code you received in the email
						</Text>
					</MediaQuery>
					<Center className="otpInput" mt={15}>
						<OTPInput
							value={OTP}
							onChange={setOTP}
							autoFocus
							OTPLength={6}
							otpType="number"
							secure
						/>
					</Center>

					<Center mt={30}>
						<Button
							onClick={otpHandler}
							style={{
								width: "150px",
								padding: "0px",
								background: "#14B8E1",
							}}
							type="submit"
						>
							Get OTP
						</Button>
					</Center>
					<Box sx={{ maxWidth: 340 }} mx="auto"></Box>
				</Container>
			</div>
			{loading && (
				<div className="LoadingModal">
					<Loader className="LoadingModal_loader" />
				</div>
			)}
		</AppShell>
	);
}
export default OTPForgotPassword;
